export default {"src":"/_next/static/media/AppointmentScheduler.63de3d57.svg","height":15,"width":13,"blurWidth":0,"blurHeight":0};